<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    lazy
    transition="scale-transition"
    :disabled="disabled"
    offset-y
    :nudge-bottom="nudgeBottom"
    :nudge-right="nudgeRight"
  >
    <slot slot="activator" />
    <v-date-picker
      v-model="date"
      no-title
      :min="minDate"
      :max="maxDate"
      :show-current="!showSelectedDate"
      :allowed-dates="allowedDates"
    >
      <v-spacer />
      <v-btn
        v-if="clearable"
        flat
        color="error"
        @click="updateValue(undefined)"
      >
        Clear
      </v-btn>
      <v-btn flat color="primary" @click="closeMenu"> Cancel </v-btn>
      <v-btn flat color="primary" @click="updateValue(date)"> OK </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
/*
This component is used to select dates by opening a small calendar in a modal
*/
export default {
  name: 'CalendarPopup',
  props: {
    value: {
      type: [Date, String],
      default() {
        return undefined;
      },
    },
    minDate: {
      type: String,
      default() {
        return '0001-01-01';
      },
    },
    maxDate: {
      type: String,
      default() {
        return '';
      },
    },
    clearable: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    showSelectedDate: {
      type: Boolean,
    },
    allowedDates: {
      type: Function,
      default() {
        return () => true;
      },
    },
  },
  data() {
    return {
      menu: false,
      date: this.value,
      nudgeBottom: '',
      nudgeRight: '',
    };
  },
  methods: {
    updateValue(newDate) {
      this.date = newDate;
      this.$refs.menu.save(newDate);
      this.$emit('input', this.date);
    },
    closeMenu() {
      this.menu = false;
    },
    focusMenu() {
      this.menu = true;
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  position: absolute !important;
}
</style>
